export const PRESET_TYPE = {
  TUTOR: 'group_call_host',
  STUDENT: 'group_call_participant',
  VIEWER: 'group_call_viewer',
};
